import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1001Model } from '../kymw1001.model';


/**
 * トップ画面お知らせを取得するサービス
 *
 * @export GetInfomationService
 * @class GetInfomation
 * @extends {PlessResponder}
 */
@Injectable()
export class GetInfomationService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW1001Model = null;
  private vo: { forWholeInfo_ColumnName: string } = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {string} リクエストXML
   * @memberof GetInfomationService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ForWholeInfo_ColumnName: this.vo.forWholeInfo_ColumnName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @memberof GetInfomationService
   */
  execute(model: KYMW1001Model, vo: { forWholeInfo_ColumnName: string }): void {
    this.model = model;
    this.vo = vo;
    this.send('getInformation', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetInfomationService
   */
  success(data: any): void {
    // getInformationServiceはkymw1002にあるため不要
    // this.model.updateTopInformation(data);
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetInfomationService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
